import Odoo from './Odoo';

class AuthAPIClass{
    logUserIn(login, password){
      var params = [
        [['is_transport_partner', '=', true], ['transport_partner_login', '=', login], ['transport_partner_password', '=', password]],
        [ 'id', 'name' ]
      ];
      return new Promise((resolve, reject) => {
        Odoo.call('res.partner', 'search_read', params, login, password).then(partners => {
          if(partners.length == 0){
            reject(new TypeError('Login lub hasło nieprawidłowe'))
          } else {
            partners[0].login = login
            partners[0].password = password
            resolve(partners[0])
          }
        }).catch(err=>{
          reject(err)
        })
      });
    }

    getPartner(id){
      var params = [
        id,
        [ 'name' ]
      ];
      return new Promise((resolve, reject) => {
        Odoo.connect().then(api => {
          api.execute_kw('res.partner', 'read', [params], function (err, partner) {
            if (err) reject(err);
            resolve(partner[0]);
          });
        });
      });
    }
}

const AuthAPI = new AuthAPIClass();

export default AuthAPI;



// WEBPACK FOOTER //
// ./src/utils/AuthAPI.js